
import * as models from './model';

export interface BulkimportCartHeader {
    cart?: models.ICartHeader;
    errors?: any;
    cartId?: string | number;
}
